import { useUpdateCloseNotesMutation } from 'app/services/projects';
import { Drawers } from 'app/types/drawer';
import NotesForm from './NotesForm';

type EditNotesProps = {
  projectId: number
}

const EditNotes = ({ projectId }: EditNotesProps) => {
  const [ updateNotes, meta ] = useUpdateCloseNotesMutation();

  const handleSubmit = async (values: any) => await updateNotes(
    {
      ProjectId: projectId,
      Comments: {
        CloseNotes: values.CloseNotes,
        QuantitiesComments: values.QuantitiesComments,
        SafetyComments: values.SafetyComments,
        OtherComments: values.OtherComments
      }
    });

  return <NotesForm
    formId={Drawers.EDIT_NOTES}
    handleSubmit={handleSubmit}
    meta={meta}
  />;
};

export default EditNotes;